const WEBSITE_CONTENT_PATH = 'content/website-content.json';

export const fetchWebsiteContent = async () => {
  try {
    const response = await fetch(
      `https://api.github.com/repos/${process.env.REACT_APP_REPO_OWNER}/${process.env.REACT_APP_REPO_NAME}/contents/${WEBSITE_CONTENT_PATH}`,
      {
        headers: {
          'Authorization': `Bearer ${process.env.REACT_APP_GITHUB_TOKEN}`,
          'Accept': 'application/vnd.github.v3+json',
        }
      }
    );

    if (response.ok) {
      const data = await response.json();
      return {
        content: JSON.parse(atob(data.content)),
        sha: data.sha
      };
    }
    return {
      content: {
        aiTrends: [],
        testingTrends: [],
        industryTrends: [],
        lastUpdated: null
      },
      sha: null
    };
  } catch (error) {
    console.error('Error fetching website content:', error);
    return { content: {}, sha: null };
  }
};

export const saveWebsiteContent = async (content, sha = null) => {
  try {
    const body = {
      message: 'Update website content',
      content: btoa(JSON.stringify(content, null, 2)),
      branch: 'main'
    };

    if (sha) body.sha = sha;

    const response = await fetch(
      `https://api.github.com/repos/${process.env.REACT_APP_REPO_OWNER}/${process.env.REACT_APP_REPO_NAME}/contents/${WEBSITE_CONTENT_PATH}`,
      {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${process.env.REACT_APP_GITHUB_TOKEN}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body)
      }
    );

    if (!response.ok) {
      throw new Error('Failed to save website content');
    }
  } catch (error) {
    console.error('Error saving website content:', error);
    throw error;
  }
};